// src/components/navbar/useNotificationStatus.ts

import { useEffect, useState } from 'react';
import { useNotificationsQuery, SeenState, User } from '../../gql/types';
const THIRTY_DAYS_AGO = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);

export function useNotificationStatus(user?: User, refreshKey?: number) {    
    const [hasUnseenNotification, setHasUnseenNotification] = useState(false);

    const { data, loading, refetch } = useNotificationsQuery({
        variables: {
            seenState: SeenState.Unseen,
            limit: 10,
            cursor: null,
        },
        fetchPolicy: 'no-cache',
        skip: !user,
    });

    useEffect(() => {
        if (user && refreshKey !== undefined) {
            refetch();
        }
    }, [refreshKey, refetch, user]);

    // Update hasUnseenNotification if there are unseen notifications in the last 30 days
    useEffect(() => {
        if (!user || loading || !data?.notifications?.edges) return;

        const unseenCount = data.notifications.edges.filter(
            edge => new Date(edge.node.createdAt) > THIRTY_DAYS_AGO
        ).length;

        setHasUnseenNotification(unseenCount > 0);

    }, [data, loading, user]);

    return { hasUnseenNotification };
}